import { observer } from "mobx-react-lite";
import { FC } from "react";
import { AuthCardGoogleButtonBase } from "@/components/auth/google/auth-card-google-button-base";

export interface AuthCardLogInWithGoogleButtonProps {
  onClick: () => void;
}

export const AuthCardLogInWithGoogleButton: FC<AuthCardLogInWithGoogleButtonProps> = observer(
  ({ onClick }) => {
    return (
      <AuthCardGoogleButtonBase
        label="Continue with Google"
        onClick={onClick}
        testId="log-in-with-google-button"
      />
    );
  }
);
